import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft, Edit } from 'lucide-react';

const ProjectDetailHeader = ({ project, onEdit }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/projects');
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleBack}
          className="flex items-center space-x-2"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>กลับ</span>
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            {project?.project_name || 'โปรเจค'}
          </h1>
          <p className="text-muted-foreground mt-2">
            รายละเอียดโปรเจคและข้อมูลทางการเงิน
          </p>
        </div>
      </div>
      <Button
        onClick={onEdit}
        className="flex items-center space-x-2"
      >
        <Edit className="h-4 w-4" />
        <span>แก้ไข</span>
      </Button>
    </div>
  );
};

export default ProjectDetailHeader;
